import Header from "./components/Header";
import Hero from "./components/Hero";
import Collection from "./components/Collection";
import Feature from "./components/Feature";
import Channels from "./components/Channels";
import Business from "./components/Business";
import Contact from "./components/Contact";
import Manifesto from "./components/Manifesto";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <Collection />
        <Feature />
        <Channels />
        <Business />
        <Contact />
        <Manifesto />
      </main>
      <Footer />
    </div>
  );
}